import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-[#030303] flex items-center justify-center px-6 text-center">
      <div>
        <p className="text-[#a83a4a] text-[10px] uppercase tracking-[0.3em] font-body mb-4">404</p>
        <h1 className="font-heading text-4xl text-white mb-3 tracking-tight">Page not found</h1>
        <p className="text-white/40 font-body text-sm mb-8">This route does not exist. Head back to the home page.</p>
        <Link to="/" className="inline-block px-6 py-3 bg-white text-black font-heading text-sm uppercase tracking-[0.2em] hover:bg-white/90 transition">
          Return Home
        </Link>
      </div>
    </div>
  );
}
